import React from "react";
import { Link } from "react-router-dom";
function Menu(){
    return(
        <div className="header-topbar with-language-right d-none d-md-block">
            <div className="container-fluid">
                <div className="d-lg-flex align-items-center justify-content-between">
                    <div className="topbar-left d-flex align-items-center">
                        <ul className="social-icon">
                            <li><a href="https://www.facebook.com/profile.php?id=61573033526358"><i className="fab fa-facebook-f" target="_blank"></i></a></li>
                            <li><a href="https://www.instagram.com/aa_digitals_marketing/"><i className="fab fa-instagram" target="_blank"></i></a></li>
                            <li><a href="https://www.linkedin.com/in/aadigitals-digital-marketing/" target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
                            <li><a href="mailto:aadigitalsmarketing@gmail.com"><i className="fas fa-envelope" target="_blank"></i></a></li>
                        </ul>
                    </div>
                    <div className="topbar-right d-flex align-items-center justify-content-lg-end">
                        <ul className="topbar-menu">
                            <li><Link to="/contact">Contact Us</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            
        </div>
    )
}
 export default Menu;